import esriConfig from '@arcgis/core/config';

/**
 * Configure Esri Maps
 * @param {String} apiKey - Esri Maps API key
 */
export const configureEsriMaps = apiKey => (esriConfig.apiKey = apiKey);

const ARRAY = 'array';
const OBJECT = 'object';
// TODO: add a test
/**
 * Normalize the center coordinates for consumption by a map provider
 * @param {Array|Object} center - {lat: yy, lng}} or [lng, lat] for the map
 * provider to center
 * @param {String} type - 'array' or 'object' to normalize to
 */
export const normalizeCenterCoordinates = (center, type) => {
  if (Array.isArray(center)) {
    if (type === OBJECT) {
      return {
        lat: center[1],
        lng: center[0],
      };
    }
    return center;
  } else {
    if (type === OBJECT) {
      return center;
    }
    return [center.lng, center.lat];
  }
};

/**
 * Normalize the shapes coordinates and return maxX, maxY, minX and minY
 * @param {Array|Object} shapes - {bottom_right, top_left} for the map
 */
export const normalizeExtent = shapes => {
  if (!Array.isArray(shapes)) {
    return null;
  } else if (!shapes.length) {
    // default to US
    return {
      xmin: -65.524514,
      ymin: 23.634763,
      xmax: -125.979106,
      ymax: 48.999968,
    };
  } else {
    // x is longitutde, y is latitude
    const maxX = shapes?.[0]?.top_left?.longitude;
    const maxY = shapes?.[0]?.top_left?.latitude;
    const minX = shapes?.[0]?.bottom_right?.longitude;
    const minY = shapes?.[0]?.bottom_right?.latitude;

    return {
      xmin: minX,
      ymin: minY,
      xmax: maxX,
      ymax: maxY,
    };
  }
};
